import { render, staticRenderFns } from "./ProductDetailTrend.vue?vue&type=template&id=2eee3b9f&scoped=true&"
import script from "./ProductDetailTrend.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailTrend.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailTrend.vue?vue&type=style&index=0&id=2eee3b9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee3b9f",
  null
  
)

export default component.exports